// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isObjectEmpty = (object: Record<string, any>) => {
  return Object.keys(object).length === 0;
};
